import React from "react";
import { observer } from "mobx-react-lite";
import cn from "classnames";
import { exists } from "../../util";
import classNames from "classnames";
const ScheduleInfo = observer(({ funboxName, locationName, scheduleSetName, offeringName, wrap, className, }) => {
    const hasOffering = Boolean(offeringName);
    const hasFunbox = Boolean(funboxName);
    const items = [
        hasFunbox && (React.createElement(Item, { key: `funbox-${funboxName}`, hasNext: true, iconClassName: "funbox-icon" }, funboxName)),
        React.createElement(Item, { key: `location-${locationName}`, hasNext: true, iconClassName: "locations-icon" }, locationName),
        React.createElement(Item, { key: `scheduleSet-${scheduleSetName}`, hasNext: hasOffering, iconClassName: "week-icon" }, scheduleSetName),
        hasOffering && (React.createElement(Item, { key: `offering-${offeringName}`, hasNext: false, iconClassName: "offerings-icon" }, offeringName)),
    ].filter(exists);
    return (React.createElement("div", { className: classNames("typography-label pointer-events-none items-center gap-1 text-gray-text-color", className), style: wrap
            ? {
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
            }
            : {
                display: "grid",
                gridTemplateColumns: `repeat(${items.length},minmax(48px,max-content))`,
            } }, items));
});
const Chevron = observer(() => {
    return React.createElement("i", { className: "icon chevron-right-icon icon-md bg-placeholder-color" });
});
const Item = observer((props) => {
    return (React.createElement("div", { className: "flex max-w-full flex-grow-0 flex-row items-center gap-1" },
        React.createElement("i", { className: cn("icon icon-md bg-main-color", props.iconClassName) }),
        React.createElement("div", { className: "flex-shrink flex-grow-0 overflow-hidden text-ellipsis whitespace-nowrap" }, props.children),
        props.hasNext && React.createElement(Chevron, null)));
});
export default ScheduleInfo;
//# sourceMappingURL=ScheduleInfo.js.map